import { buildSearchReport } from "../kernel/search.js";
import { projectBoardSummary, projectPositionSummary } from "../kernel/projectors.js";
import { createBoard, loadBoardForCommand, loadPositionForCommand } from "../kernel/board-engine.js";
import { listBoardMetadata } from "../repo/board-meta.js";
import { positionCount, withBoardDatabase } from "../repo/board-store.js";
import type { ExecutionContext } from "../runtime/context.js";
import type {
  BoardCreateRequest,
  BoardJudgeRequest,
  BoardListRequest,
  BoardShowRequest,
} from "../cli/protocol.js";

export async function handleBoardCreate(
  context: ExecutionContext,
  request: BoardCreateRequest,
) {
  const result = await createBoard(context, request.s, request.p);
  return {
    board: projectBoardSummary(result.board),
    dict: result.board.dict,
    root: projectPositionSummary(result.rootPosition),
  };
}

export async function handleBoardShow(
  context: ExecutionContext,
  request: BoardShowRequest,
) {
  const board = await loadBoardForCommand(context, request.s);
  const { position } = await loadPositionForCommand(context, request.s, "@tip");
  const totalPositions = await withBoardDatabase(context, request.s, (database) =>
    positionCount(database),
  );

  return {
    board: projectBoardSummary(board),
    current: projectPositionSummary(position),
    stats: {
      atomCount: Object.keys(position.stateSnapshot.atoms).length,
      cellCount: Object.keys(position.stateSnapshot.cells).length,
      positionCount: totalPositions,
    },
  };
}

export async function handleBoardJudge(
  context: ExecutionContext,
  request: BoardJudgeRequest,
) {
  const { board, position } = await loadPositionForCommand(context, request.s, request.p);
  const report = buildSearchReport(board, position, 1);
  return {
    board: projectBoardSummary(board),
    current: projectPositionSummary(position),
    report,
  };
}

export async function handleBoardList(
  context: ExecutionContext,
  _request: BoardListRequest,
) {
  const boards = await listBoardMetadata(context);
  return {
    boards: boards.map(projectBoardSummary),
  };
}
